import React, { useState, useContext, useEffect } from "react";
import { InfluencerCardContainer } from "./InfluencerCardStyled";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../context/userContext";

import avatar from './../../utils/images/avatar_fluincr.png';
import noCountry from './../../utils/images/world.png';

import { toUpperCase, lowerFare3, formatNumber } from "../../services/generalSevices";
import { getInfluencerLikeFromCompany } from "../../api/companyApi";
import LikeInfluencer from "../LikeInfluencer/LikeInfluencer";
import { CurrencyContext } from "../../context/currencyContext";
import { getConvertCurrency } from "../../api/exchangeApi";
import { LangContext } from "../../context/langContext";


export default function InfluencerCar({ influencer, page }) {

    const { locale } = useContext(LangContext);
    const [isFavorite, setIsFavorite] = useState(influencer.likes);
    const [price, setPrice] = useState(null);
    const navigate = useNavigate();

    const { userToken, userType, companyId } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    useEffect(() => {
        if (companyId !== -1) {
            getInfluencerLikeFromCompany({ companyId: companyId }).then((response) => {
                const likes = response
                const favorite = likes.some((element) => element.influincridlike
                    === influencer.id)
                setIsFavorite(favorite)
            })
        }
    }, [companyId])

    useEffect(() => {
        const amount = lowerFare3((influencer.price !== null) ? (influencer.price) : [0]);
        const auxCurrency = currency.symbol
        getConvertCurrency({ amount: amount }).then((response) => {
            //setPrice(response[auxCurrency].toFixed(0))
            setPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency])

    return (
        <InfluencerCardContainer page={page} >

            <div className="image" style={{ backgroundImage: `url(${(influencer.image_profile !== null) ? influencer.image_profile : avatar})` }} >

                <div className="likeContainer">
                    {(userType === 'company' || userToken === null) ? (<LikeInfluencer profileId={influencer.id} isFavorite={isFavorite} setIsFavorite={setIsFavorite} />) : (<div className="favorite" />)}
                </div>


                <div className="data">
                    <p><span className="currencySymbol">{currency.symbol}</span> {formatNumber(price)}</p>
                    {/* <p>1.1 M</p> */}
                </div>
            </div>

            <h3 className="name" onClick={() => {
                navigate(`/${influencer.username}`);
            }}>{(toUpperCase({ fullName: `${influencer.name}` }))}</h3>

            <div className="influencerData">
                <img src={(influencer.imagecountry === null) ? (noCountry) : influencer?.imagecountry} alt="" className="influencerCountry" />
                <div className="categories">

                    {(locale === 'es-CO') ? (influencer?.nombrecategory?.map((category, index) => {
                        if (index < 3) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })) : (influencer?.namecategory?.map((category, index) => {
                        if (index < 3) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    }))}
                    {/*  {influencer?.namecategory?.map((category, index) => {
                        if (index < 3) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })} */}
                </div>
            </div>
        </InfluencerCardContainer>
    )
}